import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-left\">\r\n<g clip-path=\"url(#arrow-left_clip0_1462_537)\">\r\n<path d=\"M16 4L8 12L16 20\" stroke=\"#1D1D1B\" stroke-width=\"1.3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</g>\r\n<defs>\r\n<clipPath id=\"arrow-left_clip0_1462_537\">\r\n<rect width=\"24\" height=\"24\" fill=\"white\" />\r\n</clipPath>\r\n</defs>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol